<template>
    <button
        v-if="data && data.label"
        :class="{
            'flex-col': align === 'COL' || align === 'COL-SPE',
            'flex-row-reverse': align === 'ROW',
            'aspect-square': align !== 'COL-SPE',
            'min-h-[133px] md:min-h-auto md:aspect-square': align === 'COL-SPE',
            'border-cyan-light text-cyan': selected,
            'border-white text-blue hover:border-cyan-light': !selected,
        }"
        class="choice-card relative flex justify-center items-center border-4 bg-white rounded-2xl p-4 transition-all duration-300"
        @click="btnClicked"
    >
        <span v-if="data.icon" :class="{ 'mb-3': align === 'COL' || align === 'COL-SPE', 'ml-2': align === 'ROW' }" class="relative flex justify-center items-center w-10 md:w-12 md:h-12">
            <img
                :src="require(`@/static/images/icons/${data.icon}.svg`)"
                :alt="data.label ?? ''"
                :class="{
                    'opacity-0': selected && (align === 'COL' || align === 'COL-SPE') && data.hover === 'true',
                }"
                class="transition-all duration-300 w-full"
            />
            <template v-if="data.icon && (align === 'COL' || align === 'COL-SPE') && data.hover === true">
                <img :src="require(`@/static/images/icons/${data.icon}-blue.svg`)" :alt="data.label ?? ''" :class="{ 'opacity-100': selected, 'opacity-0': !selected }" class="absolute inset-0 transition-all duration-300 w-full" />
            </template>
        </span>
        <span
            :class="{
                'w-16': align === 'ROW',
                'body-2': !data.description,
                'body-strong': data.description,
            }"
            >{{ translations[data.label] }}</span
        >
        <span v-if="data.description" class="body-2 mt-1.5 md:mt-3">{{ translations[data.description] }}</span>
        <span ref="selectIcon" class="choice-card__check flex justify-center items-center w-8 h-8 bg-white rounded-full absolute -top-2.5 -right-1.5 transform scale-0">
            <img src="~@/static/images/icons/check.svg" alt="Check" />
        </span>
    </button>
</template>

<script>
    import gsap from 'gsap';

    export default {
        name: 'ChoiceCard',

        props: {
            data: { type: Object, default: () => {} },
            translations: { type: Object, default: () => {} },
            align: { type: String, default: 'COL' },
        },

        data: () => ({
            selected: false,
        }),

        watch: {
            selected() {
                if (this.selected) {
                    // Show the select icon
                    gsap.to(this.$refs.selectIcon, {
                        scale: 1,
                        duration: 0.7,
                        ease: 'back.out',
                    });
                }
            },

            data() {
                // If the data change, it means, that the same card is used for a different question so
                // Deselect the card
                this.selected = false;

                // Hide the select icon
                gsap.set(this.$refs.selectIcon, {
                    scale: 0,
                });
            },
        },

        methods: {
            btnClicked() {
                this.selected = true;

                this.$emit('button-clicked', this.data);
            },
        },
    };
</script>

<style lang="scss">
    .choice-card {
        &__check {
            box-shadow: 0px 2.458px 3.686px 0px rgba(0, 0, 0, 0.3);
        }
    }
</style>
